import { subclass } from "esri/core/accessorSupport/decorators";
import { Point, Polygon, Polyline } from "esri/geometry";
import { TextSymbol } from "esri/symbols";
import { tsx } from "esri/widgets/support/widget";
import {
  annualConstructionLayer,
  annualEngineeringLayer,
  annualLandAcqLayer,
  annualBridgeImprovementLayer,
  ftrConstructionLayer,
  ftrEngineeringLayer,
  ftrLandAcqLayer,
  ftrStructuresLayer,
  mypRoadwayLayerCurYear, 
  mypRoadwayLayerFutureYears, 
  mypSpotLayerCurYear, 
  mypSpotLayerFutureYears, 
  mypStructuresLayerCurYear,
  mypStructuresLayerFutureYears,
  programmingGroupLayer
} from "../data/Layers/programming";
import { idotRoadsLayer, StateKRLayerWith } from "../data/Layers/baseGroup";
import {
  idotDistrictsLayer,
  ilHouseBoundariesLayer,
  illinoisCounties,
  illinoisTownsLayer,
  ilSenateBoundariesLayer,
  mpoAreasLayer,
  politicalTownshipsLayer,
  urbanAreasLayer,
  usCongressBoundariesLayer
} from "../data/Layers/boundaryLayers";
import * as pavement from "../data/Layers/pavement";
import * as layerSource from "../data/Layers/layerSource";
import * as structures from "../data/Layers/structures";
import { saveUserAttributes, clearGraphicType, returnSearchParams, getUserAttributes, urbanAreasNames, mpoNames, countyNames, districtNames, titleCase, autocomplete, highlightColor  } from "./App/setupView";
import Widget = require("esri/widgets/Widget");
import watchUtils = require("esri/core/watchUtils");
import Query = require("esri/rest/support/Query");
import QueryTask =require("esri/rest/query"); 
import Layer = require("esri/layers/Layer")
import FeatureLayer = require("esri/layers/FeatureLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import MapView = require("esri/views/MapView");
import SimpleLineSymbol = require("esri/symbols/SimpleLineSymbol");
import SimpleMarkerSymbol = require("esri/symbols/SimpleMarkerSymbol");
import Expand = require("esri/widgets/Expand");
import Geometry = require("esri/geometry/Geometry");
import promiseUtils = require("esri/core/promiseUtils");
import FeatureSet = require("esri/rest/support/FeatureSet");
import * as geometryEngine from 'esri/geometry/geometryEngine'
import webMercatorUtils = require("esri/geometry/support/webMercatorUtils");
import GraphicsLayer = require("esri/layers/GraphicsLayer");
import Extent = require("esri/geometry/Extent");
import Graphic = require('esri/Graphic');
import { string } from "dojo/main";

const CSS = {
  base: "zoomto-widget"
};

@subclass("esri.widgets.ZoomTo")
class ZoomTo extends Widget {
  // featureUpdateTable:Array<{ fieldName: string; label: string;}>;
  selectedGraphic: Graphic;
  view: MapView;
  featureUpdateTable = new Map();
  zoomExpand: Expand;
  drawLayer: GraphicsLayer;
  searchKeyRouteStr = "";
  searchEndRef = "";
  searchBeginRef = "";
  btnName = "btnPPS";
  searchPPS = "";
  searchPPSlayer = "All";
  searchBoundarylayer = "";
  searchBoundary = "";
  searchTowns = "";
  searchTownship = "";
  searchBookmarks = "";
  selectBookmarks = "";
  searchStructure = "";
  searchMarkedRouteLayer = "I";
  searchMarkedRouteCounty = "";
  inputText: HTMLInputElement | null;
  searchMarkedRouteNumber = "";
  ppsLayers = [
    { id: "null", name: "null", layer: annualEngineeringLayer as Layer },
  ];

  boundaryLayers = [
    { id: "null", name: "null", layer: annualEngineeringLayer as Layer},
  ];

  bookmarksList = [{ name: "Select Bookmark", extent: new Extent({}).toJSON() }];

  constructor() {
    super();
  }

  // -------------------------------------------------------------------
  //
  //  Public methods
  //
  // -------------------------------------------------------------------

  render() {
    return (
      <div class={CSS.base}>
        <div class="info-box">
          <div class="info-column zoomto-left">
            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="zoom-button activeBtn"
                  value="PPS"
                  id="btnPPS"
                  bind={this}
                  onclick={this.searchTypeBtnPressed}
                />
              </div>
            </div>
            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="zoom-button"
                  value="Structure"
                  id="btnStructure"
                  bind={this}
                  onclick={this.searchTypeBtnPressed}
                />
              </div>
            </div>

            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="zoom-button"
                  value="Key Route"
                  id="btnKeyRoute"
                  bind={this}
                  onclick={this.searchTypeBtnPressed}
                />
              </div>
            </div>
            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="zoom-button"
                  value="Marked Route"
                  id="btnMarkedRoute"
                  bind={this}
                  onclick={this.searchTypeBtnPressed}
                />
              </div>
            </div>
            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="zoom-button"
                  value="Boundary"
                  id="btnBoundary"
                  bind={this}
                  onclick={this.searchTypeBtnPressed}
                />
              </div>
            </div>
            <div class="info-row">
              <div class="info-column info-all">
                <input
                  type="button"
                  class="zoom-button"
                  value="Bookmarks"
                  id="btnBookmarks"
                  bind={this}
                  onclick={this.searchTypeBtnPressed}
                />
              </div>
            </div>
          </div>
          <div class="info-column zoomto-right">
            <div class="zoomto-content" id="contentZoomTo">
              <div id="PPS" style="display: block;">
                <h4>Zoom To PPS Number</h4>
                <select
                  class="mask-select"
                  id="selectPPSList"
                  style="width:200px"
                  bind={this}
                  onchange={this._selectPPSChange}
                >
                  <option value="All">All PPS Layers</option>
                  {this.ppsLayers.map(item => {
                    return <option key={item.id} value={item.id}>{item.name}</option>;
                  })}
                </select>
                <br />
                <input
                  autofocus
                  type="text"
                  class="mask-text"
                  name="PPSSearch"
                  id="PPSSearch"
                  bind={this}
                  oninput={this._zoomToPPSChange}
                  onkeyup={this._zoomToPPSKeyup}
                />
                <br />
                <input
                  type="button"
                  class="mask-button"
                  value="Zoom To"
                  id="btnSearchPPS"
                  bind={this}
                  onclick={this._searchPPS}
                />
              </div>
              <div id="Structure" style="display: none;">
                <h4>Zoom To Structure Number</h4>
                <input
                  type="text"
                  class="mask-text"
                  name="StructureSearch"
                  id="StructureSearch"
                  bind={this}
                  oninput={this._zoomToStructureChange}
                  onkeyup={this._zoomToStructureKeyup}
                />
                <input
                  type="button"
                  class="mask-button"
                  value="Zoom To"
                  id="btnSearchStructure"
                  bind={this}
                  onclick={this.SearchStructure}
                />
              </div>
              <div id="KeyRoute" style="display: none;">
                <h4>Zoom To Key Route</h4>
                  <div class="autocomplete" style="width:200px;">
                    <input
                      type="text"
                      class="mask-text"
                      name="KeyRouteSearch"
                      id="KeyRouteSearch"
                      autocomplete='off'
                      style="width:200px"
                      placeholder="Key Route"
                      bind={this}
                      oninput={this._zoomToKeyRouteInput}
                      // onkeyup={this._zoomToKeyRouteKeyup}
                    />
                  </div>
                <p>Begin Ref:
                <input
                  type="number"
                  class="mask-text"
                  name="KeyRouteBeginRef"
                  id="KeyRouteBefinRef"
                  style="width:60px; margin-left:20px"
                  step="0.01"
                  min="0"
                  max="9999"
                  bind={this}
                  oninput={this._zoomToBeginRefChange}
                  onkeyup={this._zoomToBeginRefKeyup}
                />
                <br />
                End Ref:
                <input
                  type="number"
                  class="mask-text"
                  style="width:60px; margin-left:32px"
                  name="KeyRouteEndRef"
                  id="KeyRouteEndRef"
                  step="0.01"
                  min="0"
                  max="9999"
                  bind={this}
                  oninput={this._zoomToEndRefChange}
                  onkeyup={this._zoomToEndRefKeyup}
                /></p>
                <input
                  type="button"
                  class="mask-button"
                  value="Zoom To"
                  id="btnSearchKeyRoute"
                  bind={this}
                  onclick={this._searchKeyRouteParams}
                />
              </div>
              <div id="MarkedRoute" style="display: none;">
                <h4>Zoom To Marked Route</h4>
                <select
                  class="mask-select"
                  id="selectMarkedRouteList"
                  style="width:200px"
                  bind={this}
                  onchange={this._selectMarkedRouteChange}
                >
                  <option value="I">Interstate</option>
                  <option value="U">US Hwy</option>
                  <option value="S">State Hwy</option>
                </select>
                <br />
                <p>
                County #:
                <input
                  type="text"
                  class="mask-text"
                  name="MarkedRouteCounty"
                  id="MarkedRouteCounty"
                  style="width:60px"
                  bind={this}
                  oninput={this._markedRouteCountyChange}
                  onkeyup={this._markedRouteCountyKeyup}
                />
                <br />
                Route #:
                <input
                  type="text"
                  class="mask-text"
                  style="width:60px; margin-left:16px"
                  name="MaskedRouteNumber"
                  id="MaskedRouteNumber"
                  bind={this}
                  oninput={this._markedRouteNumberChange}
                  onkeyup={this._markedRouteNumberKeyup}
                />
                </p>
                <br />
                <input
                  type="button"
                  class="mask-button"
                  value="Zoom To"
                  id="btnSearchMarkedRoute"
                  bind={this}
                  onclick={this._searchMarkedRoute}
                />
              </div>
              <div id="Boundary" style="display: none;">
                <h4>Zoom To Boundary</h4>
                <select
                  class="mask-select"
                  id="selectBoundaryList"
                  style="width:200px"
                  bind={this}
                  onchange={this._selectBoundaryChange}
                >
                  {this.boundaryLayers.map(item => {
                    return <option key={item.id} value={item.name}>{item.name}</option>;
                  })}
                </select>
                <br />
                <p style="margin-left:10px; margin-top:5px; margin-bottom:5px; font-size:small" id="prompt" />
                <select
                  class="mask-select"
                  id="selectMPO"
                  style="width:200px; display:none"
                  bind={this}
                  onchange={this._selectMPOChange}
                >
                  {mpoNames.map(item => {
                    return (
                      <option key={item.index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <select
                  class="mask-select"
                  id="selectUrbanAreas"
                  style="width:200px; display:none"
                  bind={this}
                  onchange={this._selectUrbanAreasChange}
                >
                  {urbanAreasNames.map(item => {
                    return (
                      <option key={item.index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <select
                  class="mask-select"
                  id="selectCounties"
                  style="width:200px; display:none"
                  bind={this}
                  onchange={this._selectCountiesChange}
                >
                  {countyNames.map(item => {
                    return (
                      <option key={item.index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <select
                  class="mask-select"
                  id="selectDistricts"
                  style="width:200px; display:none"
                  bind={this}
                  onchange={this._selectDistrictsChange}
                >
                  {districtNames.map(item => {
                    return (
                      <option key={item.index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <input
                  type="text"
                  class="mask-text"
                  name="BoundarySearch"
                  id="BoundarySearch"
                  bind={this}
                  oninput={this._zoomToBoundaryChange}
                  onkeyup={this._zoomToBoundaryKeyup}
                />
                <div class="autocomplete" id="zoomShowTownship" style="width:200px; display:none">
                  <input
                    autocomplete="off"
                    type="text"
                    class="mask-text"
                    id="zoomSelectTownship"
                    style="width:200px;"
                    bind={this}
                    oninput={this._selectTownshipChange}
                  />
                </div>
                <div class="autocomplete" id="zoomShowTowns" style="width:200px; display:none">
                  <input
                    type="text"
                    class="mask-text"
                    id="zoomSelectTowns"
                    autocomplete="off"
                    style="width:200px;"
                    bind={this}
                    oninput={this._selectTownsChange}
                  />
                </div>
                <br />
                <input
                  type="button"
                  class="mask-button"
                  value="Zoom To"
                  id="btnSearchBoundary"
                  bind={this}
                  onclick={this._searchBoundary}
                />
              </div>
              <div id="Bookmarks" style="display: none;">
                <h4>Zoom To Bookmarks</h4>
                <select
                  class="mask-select"
                  id="selectBookmarksList"
                  style="width:200px"
                  bind={this}
                  onchange={this._selectBookmarksChange}
                >
                  {this.bookmarksList.map(item => {
                    return (
                      <option key={item.name} value={item.name}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <br />
                <input
                  autofocus
                  type="text"
                  class="mask-text"
                  name="BookmarksSearch"
                  id="BookmarksSearch"
                  style="width:200px"
                  bind={this}
                  oninput={this._zoomToBookmarksChange}
                />
                <br />
                <input
                  type="button"
                  class="mask-button"
                  value="Add"
                  id="btnAddBookmarks"
                  style="width:60px"
                  bind={this}
                  onclick={this._addBookmarks}
                />
                <input
                  type="button"
                  class="mask-button"
                  value="Remove"
                  id="btnRemoveBookmarks"
                  style="width:80px"
                  bind={this}
                  onclick={this._removeBookmarks}
                />
                <input
                  type="button"
                  class="mask-button"
                  value="Remove All"
                  id="btnRemoveAllBookmarks"
                  style="width:100px"
                  bind={this}
                  onclick={this._removeAllBookmarks}
                />
              </div>
              <p style="margin-left:35px; margin-top:5px; color:red" id="messageZoom" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  init(viewIn: MapView, zoomExpandIn: Expand) {
    try {
      // console.log("ZoomTo init");
      this.view = viewIn;
      this.zoomExpand = zoomExpandIn;
      this.drawLayer = viewIn.map.findLayerById("drawLayer") as GraphicsLayer;

      const bookmarkListCookie = getUserAttributes("IDOT_IROADS_bookmarksList");
      if (bookmarkListCookie) {
        this.bookmarksList = bookmarkListCookie;
      }

      this.ppsLayers = [
        { id: "PUBLISHEDANNENGINEERING", name: annualEngineeringLayer.title, layer: annualEngineeringLayer },
        { id: "PUBLISHEDANNLANDACQUISITION", name: annualLandAcqLayer.title, layer: annualLandAcqLayer },
        { id: "PUBLISHEDANNCONSTRUCTION", name: annualConstructionLayer.title, layer: annualConstructionLayer },
        { id: "PUBLISHEDANNBRIDGEIMPROVEMENT", name: annualBridgeImprovementLayer.title, layer: annualBridgeImprovementLayer },

        { id: "PUBLISHEDFTRENGINEERING", name: ftrEngineeringLayer.title, layer: ftrEngineeringLayer },
        { id: "PUBLISHEDFTRLANDACQUISITION", name: ftrLandAcqLayer.title, layer: ftrLandAcqLayer },
        { id: "PUBLISHEDFTRCONSTRUCTION", name: ftrConstructionLayer.title, layer: ftrConstructionLayer },
        { id: "PUBLISHEDFTRSTRUCTURES", name: ftrStructuresLayer.title, layer: ftrStructuresLayer },

        { id: "PUBLISHEDMYPROADWAY", name: mypRoadwayLayerCurYear.title, layer: mypRoadwayLayerCurYear },
        { id: "PUBLISHEDMYPROADWAYFUTURE", name: mypRoadwayLayerFutureYears.title, layer: mypRoadwayLayerFutureYears },
        { id: "PUBLISHEDMYPSPOTS", name: mypSpotLayerCurYear.title, layer: mypSpotLayerCurYear },
        { id: "PUBLISHEDMYPSPOTSFUTURE", name: mypSpotLayerFutureYears.title, layer: mypSpotLayerFutureYears },
        { id: "PUBLISHEDMYPSTRUCTURES", name: mypStructuresLayerCurYear.title, layer: mypStructuresLayerCurYear },
        { id: "PUBLISHEDMYPSTRUCTURESFUTURE", name: mypStructuresLayerFutureYears.title, layer: mypStructuresLayerFutureYears }
      ];
    
      this.boundaryLayers = [
        { id: "", name: "Select Boundary", layer: mypRoadwayLayerCurYear },
        { id: idotDistrictsLayer.sublayers.getItemAt(0).id.toString(), name: "IDOT Districts", layer: idotDistrictsLayer },
        { id: usCongressBoundariesLayer.sublayers.getItemAt(0).id.toString(), name: "Congressional (2023)", layer: usCongressBoundariesLayer },
        { id: ilHouseBoundariesLayer.sublayers.getItemAt(0).id.toString(), name: "IL House Rep. (2023)", layer: ilHouseBoundariesLayer },
        { id: ilSenateBoundariesLayer.sublayers.getItemAt(0).id.toString(), name: "IL Senate (2023)", layer: ilSenateBoundariesLayer },
        { id: politicalTownshipsLayer.sublayers.getItemAt(0).id.toString(), name: "Political Township", layer: politicalTownshipsLayer },
        { id: illinoisCounties.sublayers.getItemAt(0).id.toString(), name: "Illinois Counties", layer: illinoisCounties },
        { id: urbanAreasLayer.sublayers.getItemAt(0).id.toString(), name: "Urban Areas", layer: urbanAreasLayer },
        { id: mpoAreasLayer.sublayers.getItemAt(0).id.toString(), name: "MPO Areas", layer: mpoAreasLayer },
        { id: illinoisTownsLayer.sublayers.getItemAt(0).id.toString(), name: "Towns", layer: illinoisTownsLayer }
      ];
    }
    catch (error) {
      console.error(" error in ZoomTo.init ", error);
    }

  }

  setSearchLayer(layer: any) {
    const ppsID = this._findPPSIDByLayer(layer);
    const boundary = this._findBoundaryById(layer.id);
    if (ppsID !== "" || layer.id === programmingGroupLayer.id) {
      this.btnName = "btnPPS";
      this.searchTypeBtnPressed();
      const selectPPSList = document.getElementById("selectPPSList") as HTMLSelectElement;
      if (ppsID === "")
      {
        selectPPSList.selectedIndex = 0;
      }
      else
      {
        selectPPSList.value = ppsID;
      }
    } else if (
      layer.title.toLowerCase() === pavement.pavementGroupLayer.title.toLowerCase()
    ) {
      this.btnName = "btnKeyRoute";
      this.searchTypeBtnPressed();
    } else if (layer.title.toLowerCase() === structures.structuresGroupLayer.title.toLowerCase() || 
               layer.title.toLowerCase() === structures.stateStructuresLayer.title.toLowerCase() ||
               layer.title.toLowerCase() === structures.localStructuresLayer.title.toLowerCase()) {
        this.btnName = "btnStructure";
      this.searchTypeBtnPressed();
    } else if (boundary.layer === layer) {
      this.btnName = "btnBoundary";
      this.searchTypeBtnPressed();
      const selectBoundaryList = document.getElementById("selectBoundaryList") as HTMLSelectElement;
      selectBoundaryList.value = boundary.name;
      this.searchBoundarylayer = boundary.id;
      this._selectBoundaryChange();
    }
  }

  searchTypeBtnPressed(event?: MouseEvent) {
    // console.log("Button press", event);
    if (event && event.srcElement) {
      this.btnName = (event.srcElement as HTMLElement).id;
    }

    if (this._showMessage) {
      this._showMessage("");
    }

    if (this.btnName.indexOf("btn") === 0) {
      const pps = document.getElementById("PPS") as HTMLDivElement;
      const structure = document.getElementById("Structure") as HTMLDivElement;
      const keyRoute = document.getElementById("KeyRoute") as HTMLDivElement;
      const markedRoute = document.getElementById("MarkedRoute") as HTMLDivElement;
      const boundary = document.getElementById("Boundary") as HTMLDivElement;
      const bookmarks = document.getElementById("Bookmarks") as HTMLDivElement;

      pps.style.display = "none";
      structure.style.display = "none";
      keyRoute.style.display = "none";
      markedRoute.style.display = "none";
      boundary.style.display = "none";
      bookmarks.style.display = "none";

      const buttons = document.getElementsByClassName("zoom-button");
      if (buttons) {
        for (let i = 0; i < buttons.length; i++) {
          if (buttons[i]) {
            buttons[i].className = buttons[i].className.replace(" activeBtn", "");
            if (buttons[i].id === this.btnName) {
              buttons[i].className += " activeBtn";
            }
          }
        }
      }

      switch (this.btnName) {
        case "btnPPS":
          pps.style.display = "block";
          this.inputText = document.getElementById("PPSSearch") as HTMLInputElement;
          break;
        case "btnStructure":
          structure.style.display = "block";
          this.inputText = document.getElementById("StructureSearch") as HTMLInputElement;
          break;
        case "btnKeyRoute":
          keyRoute.style.display = "block";
          this.inputText = document.getElementById("KeyRouteSearch") as HTMLInputElement;
          break;
        case "btnMarkedRoute":
          markedRoute.style.display = "block";
          this.inputText = document.getElementById("selectMarkedRouteList") as HTMLInputElement;
          break;
        case "btnBoundary":
          boundary.style.display = "block";
          this.inputText = document.getElementById("BoundarySearch") as HTMLInputElement;
          break;
        case "btnBookmarks":
          bookmarks.style.display = "block";
          this.inputText = document.getElementById("BookmarksSearch") as HTMLInputElement;
          break;
        default:
          break;
      }

      if (this.inputText) {
        this.inputText.focus();
      }
    }
  }

  searchKeyRoute(kr:string, BegSta:string, EndSta:string, popup:boolean=false) {
    this._clearResult();
    if (kr.trim() === "") {
      this._showMessage("Enter search");
    } else {
      try {
        document.body.style.cursor = "wait";
        
        const searchStr = this._normalizeKeyRoute(kr);
        if (searchStr.length > 3) {

          const beginRefStr = BegSta.trim();
          const endRefStr = EndSta.trim();

          // if (
          //   searchStr.slice(-1) !== "%" &&
          //   (searchStr.length === 10 || searchStr.length === 11)
          // ) {
          //   searchStr += "%"; // add wild card if shortened search, 077  06040, and no stations specified.
          // }

          let searchQuery = "INVENTORY " + "= '" + searchStr + "'";

          // if(beginRefStr !== '' && endRefStr !== ''){
          //   searchQuery = searchQuery + " AND BEG_STA>=" + beginRefStr + " " + "AND END_STA<=" + endRefStr + " "
          // }

          const query = new Query({
            outFields: ["*"],
            where:
              searchQuery,
            outSpatialReference: { wkid: 4326 },
            returnGeometry: true,
            returnM: true
          });

          StateKRLayerWith
            .queryFeatures(query)
            .then(results => {
              if (results && results.features && results.features.length > 0) {
                this._showCombinedResult(results.features, true, beginRefStr, endRefStr);
              } else {
                this._showMessage("Not Found");
                if (popup) {
                  alert("Key Route not found " + kr);
                }
              }
            })
            .catch(() => {
              this._showMessage("Not Found !!");
              if (popup) {
                alert("Key Route not found " + kr);
              }
          });
        } else {
          this._showMessage("Not Found !!");
          if (popup) {
            alert("Key Route not found " + kr);
          }
        }
      } catch (error) {
        console.error(" error in searchKeyRoute ", error);
        this._showMessage("Error in search !!");
      }
    }
  }

  SearchStructure(inSn = "") {
    // console.log("ZoomTo Search Structure = ", this.searchStructure);
    this._clearResult();
    if ((typeof inSn) === "string" && inSn !== "")
    {
      this.searchStructure = inSn;
    }

    if (this.searchStructure === "") {
      this._showMessage("Enter search");
    } else {
      try {
        let search = this.searchStructure.trim().replace(/[^0-9]/g, ""); // trim non-numeric
        if (search.length > 3) {
          search = search.slice(0, 3) + "-" + search.slice(3);
        }
        const query = new Query({
          outFields: ["*"],
          where: "SN='" + search + "'",
          outSpatialReference: { wkid: 4326 },
          returnGeometry: true
        });

        structures.stateStructuresLayer
          .queryFeatures(query)
          .then(results => {
            if (results && results.features && results.features.length > 0 && results.features[0].geometry !== null) {
              // console.log(" State Structure Search Results = ", results.features.length);
              if ((typeof inSn) === "string" && inSn !== "")
              {
                structures.stateStructuresLayer.visible = true;
              }
              this._showResult([results.features[0]]);
            } else {
              structures.localStructuresLayer
                .queryFeatures(query)
                .then(results2 => {
                  if (results2 && results2.features && results2.features.length > 0 && results2.features[0].geometry !== null) {
                  //   console.log(" Local Structure Search Results = ", results2.features.length);
                        if ((typeof inSn) === "string" && inSn !== "")
                        {
                          structures.localStructuresLayer.visible = true;
                        }
                        this._showResult([results2.features[0]]);
                  } else {
                    this._showResult([]);
                  }
                })
                .catch(error => {
                  console.error("Error: in localStructuresLayer search " + error.message);
                  this._showMessage("Error in search !!");
                });
            }
          })
          .catch(error => {
            console.error("Error: in stateStructuresLayer search " + error.message);
            this._showMessage("Error in search !!");
          });
      } catch (error) {
        console.error("Error: in _searchStructure " + error.message);
        this._showMessage("Error in search !!");
      }
    }
  }

  private _searchKeyRouteParams() {
    this.searchKeyRoute(this.searchKeyRouteStr, this.searchBeginRef, this.searchEndRef);
  }

  private _zoomToPPSKeyup(event: KeyboardEvent) {
    // console.log("keyup ", event);
    if (event.key === "Enter") {
      this._searchPPS();
    }
  }

  private _zoomToPPSChange(event: MouseEvent) {
    // console.log("Button press", event);
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      // console.log(" Mask Text = ", input.value);
      this.searchPPS = input.value;
    }
  }

  private _zoomToBoundaryKeyup(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this._searchBoundary();
    }
  }

  private _zoomToBoundaryChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchBoundary = input.value;
    }
  }

  private _zoomToBookmarksChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchBookmarks = input.value;
    }
  }

  private _zoomToStructureKeyup(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.SearchStructure();
    }
  }

  private _zoomToStructureChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchStructure = input.value;
    }
  }

  // private _zoomToKeyRouteKeyup(event: KeyboardEvent) {
  //   if (event.key === "Enter") {
  //     this._searchKeyRouteParams();
  //   }
  // }

  private _queryKeyRouteSuggestions(keyRoute:string) {
    const searchStr = this._normalizeKeyRoute(keyRoute);
    if (searchStr.length >= 7) {

      const query = new Query({
        outFields: ["INVENTORY"],
        orderByFields: ["INVENTORY"],
        where:
          "INVENTORY LIKE '" +
          searchStr +
          "%' ",
        outSpatialReference: { wkid: 4326 },
        returnDistinctValues: true,
        returnGeometry: false
      });

      idotRoadsLayer
        .queryFeatures(query)
        .then(results => {
          const inv:string[] = [];
          for (let i=0; i<Math.min(8, results.features.length); i++) {
            if (results.features[i]) {
              inv.push(this._normalizeKeyRoute(results.features[i].attributes.INVENTORY));
            }
          };
          autocomplete(document.getElementById("KeyRouteSearch") as HTMLInputElement, inv, this._normalizeKeyRoute);        
        })
        .catch(() => {
          autocomplete(document.getElementById("KeyRouteSearch") as HTMLInputElement, []);        
        });
    } else {
      autocomplete(document.getElementById("KeyRouteSearch") as HTMLInputElement, []);        
    }
  }

  private _queryTownsSuggestions(town:string) {
    if (town.trim().length >= 2) {

      const queryTowns = new Query({
        outFields: ["IDOT_NAME"],
        orderByFields: ["IDOT_NAME"],
        where: "lower(IDOT_NAME) LIKE lower('" + town.trim() + "%')",
        returnDistinctValues: true,
        returnGeometry: false
      });

      const sublayer = illinoisTownsLayer.sublayers.getItemAt(0);
      sublayer
        .queryFeatures(queryTowns)
        .then(results => {
          const towns:string[] = [];
          for (let i=0; i<Math.min(5, results.features.length); i++) {
            if (results.features[i]) {
              towns.push(titleCase(results.features[i].attributes.IDOT_NAME));
            }
          };
          autocomplete(document.getElementById("zoomSelectTowns") as HTMLInputElement, towns, titleCase);        
          })
        .catch(() => {
          autocomplete(document.getElementById("zoomSelectTowns") as HTMLInputElement, []);        
        });
    } else {
      autocomplete(document.getElementById("zoomSelectTowns") as HTMLInputElement, []);        
    }
  }

  private _queryTownshipSuggestions(town:string) {
    if (town.trim().length >= 2) {

      const queryTowns = new Query({
        outFields: ["NAME"],
        orderByFields: ["NAME"],
        where: "lower(NAME) LIKE lower('" + town.trim() + "%')",
        returnDistinctValues: true,
        returnGeometry: false
      });

      const sublayer = politicalTownshipsLayer.sublayers.getItemAt(0);
      sublayer
        .queryFeatures(queryTowns)
        .then(results => {
          const towns:string[] = [];
          for (let i=0; i<Math.min(5, results.features.length); i++) {
            if (results.features[i]) {
              towns.push(titleCase(results.features[i].attributes.NAME));
            }
          };
          autocomplete(document.getElementById("zoomSelectTownship") as HTMLInputElement, towns, titleCase);        
          })
        .catch(() => {
          autocomplete(document.getElementById("zoomSelectTownship") as HTMLInputElement, []);        
        });
    } else {
      autocomplete(document.getElementById("zoomSelectTownship") as HTMLInputElement, []);        
    }
  }

  private _selectTownsChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchTowns = input.value;
      this._queryTownsSuggestions(this.searchTowns);
    }
  }

  private _selectTownshipChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchTownship = input.value;
      this._queryTownshipSuggestions(this.searchTownship);
    }
  }


  private _zoomToKeyRouteInput(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchKeyRouteStr = input.value;
      // console.log("_zoomToKeyRouteInput '" + this.searchKeyRouteStr + "'");
      this._queryKeyRouteSuggestions(this.searchKeyRouteStr);
    }
  }

  private _zoomToBeginRefKeyup(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this._searchKeyRouteParams();
    }
  }

  private _zoomToBeginRefChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchBeginRef = input.value;
    }
  }

  private _zoomToEndRefKeyup(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this._searchKeyRouteParams();
    }
  }

  private _zoomToEndRefChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchEndRef = input.value;
    }
  }
  private _markedRouteCountyKeyup(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this._searchMarkedRoute();
    }
  }

  private _markedRouteCountyChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchMarkedRouteCounty = input.value;
    }
  }

  private _markedRouteNumberKeyup(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this._searchMarkedRoute();
    }
  }

  private _markedRouteNumberChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchMarkedRouteNumber = input.value;
    }
  }

  private _findPPSLayerByID(id: string): Layer {
    let retLayer:Layer = annualConstructionLayer;
    for (const layer of this.ppsLayers) {
      if (layer.id === id) {
        retLayer = layer.layer;
        break;
      }
    }
    return retLayer;
  }

  // private _findBoundaryByName(name: string) {
  //   let retLayer = { id: "", name: "", layer: idotDistrictsLayer as Layer };
  //   for (const item of this.boundaryLayers) {
  //     if (item.name === name) {
  //       retLayer = item;
  //       break;
  //     }
  //   }
  //   return retLayer;
  // }

  private _findBoundaryById(id: string) {
    let retLayer = { id: "", name: "", layer: idotDistrictsLayer as Layer };
    for (const item of this.boundaryLayers) {
      if (item.layer.id === id || item.id === id) {
        retLayer = item;
        break;
      }
    }
    return retLayer;
  }

  private _findPPSIDByLayer(layerSearch: any): string {
    let retID = "";
    for (const layer of this.ppsLayers) {
      if (layer.layer === layerSearch) {
        retID = layer.id;
        break;
      }
    }
    return retID;
  }

  private _searchPPSbyLayer(layer: Layer, pps: string) {
    const query = new Query({
      outFields: ["*"],
      where: "PPSProject='" + pps.trim() + "'",
      returnGeometry: true
    });

    if (layer instanceof MapImageLayer) {
      const sublayer = layer.sublayers.getItemAt(0);
      sublayer
        .queryFeatures(query)
        .then(results => {
          this._showResult(results.features);
        })
        .catch(error => {
          console.error("Error: in _searchPPSbyLayer " + error.message);
          this._showMessage("Error in search !!");
        });
    } else if (layer instanceof FeatureLayer) {
      layer
        .queryFeatures(query)
        .then(results => {
          this._showResult(results.features);
        })
        .catch(error => {
          console.error("Error: in _searchPPSbyLayer " + error.message);
          this._showMessage("Error in search !!");
        });
    }
  }

  private queryPPSlayers(features: Graphic[]): any {
    // console.log("queryPPSLayer, features = ", features);
    return promiseUtils.eachAlways(
      features.map(feature => {
        // console.log("queryPPSLayer, feature = ", feature);
        const query = new Query({
          outFields: ["*"],
          where: "OBJECTID=" + feature.attributes.SourceOBJECTID,
          returnGeometry: true
        });

        const layer = this._findPPSLayerByID(feature.attributes.SourceTable as string);
        if (layer instanceof MapImageLayer) {
          const sublayer = layer.sublayers.getItemAt(0);
          return sublayer.queryFeatures(query);
        } else if (layer instanceof FeatureLayer) {
          return layer.queryFeatures(query);
        }
      })
    );
  }

  private _searchPPS() {
    this._clearResult();

    if (this.searchPPS === "") {
      this._showMessage("Enter search");
    } else {
      try {
        document.body.style.cursor = "wait";
        const search = this.searchPPS.trim().replace(/[^0-9]/g, ""); // trim non numeric

        if (this.searchPPSlayer === "All") {
          QueryTask.executeQueryJSON(layerSource.serverUrl + "/" + layerSource.PPSSearchTable.toString(), {  // autocasts as new Query()
            outFields: ["*"],
            where: "PPSProject='" + search + "'"
          }).then(results => {
              if (results && results.features && results.features.length > 0) {
                // console.log(" PPS Search Results = ", results.features.length);
                // results.features.forEach(feature => {
                //   console.log("++ Layer = ", feature.attributes.SourceTable, " OID = ", feature.attributes.SourceOBJECTID);
                // });

                const allGraphics: Graphic[] = [];
                this.queryPPSlayers(results.features).then((eachAlwaysResult: __esri.EachAlwaysResult[]) => {
                  eachAlwaysResult.forEach(result => {
                    if (result.error) {
                      console.error("Error in queryPPSLayers ", result.error);
                    } else {
                      // console.log ("Success in queryPPSLayers ", result);
                      if (result.value instanceof FeatureSet) {
                        const featureSet = result.value as FeatureSet;
                        if (featureSet.features.length === 1) {
                          const newGraphic = featureSet.features[0].clone();
                          allGraphics.push(newGraphic);
                        }
                      }
                    }
                  });
                  this._showResult(allGraphics);
                });

                // this._searchPPSbyLayer(
                //   this._findPPSLayerByID(results.features[0].attributes.SourceTable as string),
                //   results.features[0].attributes.PPSProject
                //   // ,results.features[0].attributes.SourceOBJECTID  get back all results for pps num instead
                // );
              } else {
                this._showMessage("Not Found !!");
              }
            })
            .catch(error => {
              console.error("Error in ppsQuery", error);
              this._showMessage("Error in search !!");
            });
        } else {
          this._searchPPSbyLayer(this._findPPSLayerByID(this.searchPPSlayer), search);
        }
      } catch (error) {
        console.error(" error in _searchPPS ", error);
        this._showMessage("Error in search !!");
      }
    }
  }

  private _normalizeKeyRoute(inputKey:string):string {
    let searchStr = inputKey.trim();
    // Assume 2 spaces after County, unless it's Cook county, 016
    if (searchStr.length > 3 && searchStr.substr(0,3) !== "016") {
      if (searchStr[3] !== " ") {
        // Missing first space 07706040 003875
        searchStr = searchStr.slice(0, 3) + " " + searchStr.slice(3);
      }

      if (searchStr[4] !== " ") {
        // Missing second space 077 06040 003875
        searchStr = searchStr.slice(0, 4) + " " + searchStr.slice(4);
      }
    }
    return searchStr;
  }

  private _searchMarkedRoute() {
    this._clearResult();
    if (this.searchMarkedRouteNumber === "") {
      this._showMessage("Enter route number");
    } else {
      try {
        document.body.style.cursor = "wait";

        let suffix = "";
        let searchRouteNumber = this.searchMarkedRouteNumber.trim();
        if (searchRouteNumber.slice(-1) > "9") {
          // character, trim off and save;
          suffix = searchRouteNumber.slice(-1).toUpperCase();
          searchRouteNumber = searchRouteNumber.slice(0, searchRouteNumber.length - 1);
        }

        const searchCounty = ("000" + this.searchMarkedRouteCounty.trim().replace(/[^0-9]/g, "")).slice(-3); // trim non-numeric

        const searchRoute = this.searchMarkedRouteLayer + ("000" + searchRouteNumber).slice(-3) + suffix;
        const query = new Query({
          outFields: ["*"],
          num: 5000,
          where:
            "(MARKED_RT = '" +
            searchRoute +
            "' OR " +
            "MARKED_RT2 = '" +
            searchRoute +
            "' OR " +
            "MARKED_RT3 = '" +
            searchRoute +
            "' OR " +
            "MARKED_RT4 = '" +
            searchRoute +
            "')" +
            (this.searchMarkedRouteCounty !== "" ? " AND INVENTORY LIKE '" + searchCounty + "%'" : ""),
          outSpatialReference: { wkid: 4326 },
          returnGeometry: true
        });

        idotRoadsLayer
          .queryFeatures(query)
          .then(results => {
            this._showCombinedResult(results.features, false);
          })
          .catch(error => {
            console.error("Error: in _searchMarkedRoute " + error.message);
            this._showMessage("Error in search !!");
          });
      } catch (error) {
        console.error(" error in _searchMarkedRoute ", error);
        this._showMessage("Error in search !!");
      }
    }
  }

  private _addBookmarks() {
    try {
      this._showMessage("");

      if (this.searchBookmarks !== "") {
        const bookmark = this._findBookmark(this.searchBookmarks);
        if (bookmark && bookmark.name !== "") {
          this._showMessage("Duplicate bookmark!");
        } else {
          if (this.bookmarksList.length > 20) {
            this._showMessage("Maximum of 20 bookmarks!");
          } else {
            this.bookmarksList.push({ name: this.searchBookmarks, extent: this.view.extent.toJSON() });
            saveUserAttributes("IDOT_IROADS_bookmarksList", this.bookmarksList);
          }
        }
      }
      if (this.inputText) {
        this.inputText.focus();
      }
    } catch (error) {
      console.error("Error: in _addBookmarks " + error.message);
      this._showMessage("Error in Bookmarks !!");
    }
  }

  private _removeAllBookmarks() {
    this._showMessage("");
    if (confirm("Are you sure you want to remove all of your bookmarks?")) {
      this.bookmarksList.splice(1, this.bookmarksList.length - 1);
      saveUserAttributes("IDOT_IROADS_bookmarksList", this.bookmarksList);
    } else {
      // Do nothing!
    }
  }

  private _removeBookmarks() {
    try {
      this._showMessage("");
      if (this.selectBookmarks !== "" && this.selectBookmarks !== "Select Bookmark") {
        const bookmark = this._findBookmark(this.selectBookmarks);
        if (bookmark && bookmark.name !== "") {
          const bookmarkIndex = this.bookmarksList.indexOf(bookmark);
          this.bookmarksList.splice(bookmarkIndex, 1);
          saveUserAttributes("IDOT_IROADS_bookmarksList", this.bookmarksList);
          this.selectBookmarks = "Select Bookmark";
          if (this.inputText) {
            this.inputText.value = "";
          }
        } else {
          this._showMessage("Not found!");
        }
      }
      if (this.inputText) {
        this.inputText.focus();
      }
    } catch (error) {
      console.error("Error: in _removeBookmarks " + error.message);
      this._showMessage("Error in Bookmarks !!");
    }
  }

  private _normalizeBoundarySearch(search:string):string {
    const serachParams = returnSearchParams(this.searchBoundarylayer);
    let searchStr = search.trim();
    if (
      serachParams.suffix !== "" &&
      searchStr.toLowerCase().slice(-serachParams.suffix.length) !== serachParams.suffix
    ) {
      searchStr += serachParams.suffix;
    }
    return searchStr;
  }

  private _searchBoundary() {
    this._clearResult();

    let searchStr = this.searchBoundary;
    switch (this.searchBoundarylayer) {
      case layerSource.IllinoisTownsLayer.toString() :
        searchStr = this.searchTowns;
        break;
      case layerSource.PoliticalTownshipsLayer.toString():
        searchStr = this.searchTownship;
        break;
    }

    if (this.searchBoundarylayer === "") {
      this._showMessage("Select Boundary Layer");
    } else if (searchStr === "" || searchStr === "None" || searchStr.slice(0, 7) === "Select ") {
      if (this.searchBoundarylayer === layerSource.MPOAreasLayer.toString()) {
        this._showMessage("Select MPO");
      } else if (this.searchBoundarylayer === layerSource.UrbanAreasLayer.toString()) {
        this._showMessage("Select Urban Area");
      } else if (this.searchBoundarylayer === layerSource.IllinoisCountiesLayer.toString()) {
        this._showMessage("Select County");
      } else if (this.searchBoundarylayer === layerSource.IDOTDistrictsLayer.toString()) {
        this._showMessage("Select District");
      } else  {
        this._showMessage("Enter search");
      }
    } else {
      try {
        document.body.style.cursor = "wait";

        const serachParams = returnSearchParams(this.searchBoundarylayer);

        searchStr = this._normalizeBoundarySearch(searchStr);

        const query = new Query({
          outFields: ["*"],
          where: serachParams.numeric
            ? serachParams.search + " = " + searchStr
            : "lower(" + serachParams.search + ") = lower('" + searchStr + "')",
          returnGeometry: true
        });

        const boundary = this._findBoundaryById(this.searchBoundarylayer);

        if (boundary.id !== "" && boundary.layer instanceof MapImageLayer) {
          const sublayer = (boundary.layer as MapImageLayer).sublayers.getItemAt(0);
          sublayer
            .queryFeatures(query)
            .then(results => {
              this._showResult(results.features);
            })
            .catch(() => {
              this._showMessage("Not Found !!");
            });
        } else {
          this._showMessage("Error in Search !!");
        }
      } catch (error) {
        console.error("Error in searchBoundary ", error);
        this._showMessage("Error in Search !!");
      }
    }
  }
  private _selectPPSChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchPPSlayer = input.value;
      if (this.inputText) {
        this.inputText.focus();
      }
      this._showMessage("");
    }
  }

  private _selectMPOChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchBoundary = input.value;
    }
  }

  private _selectUrbanAreasChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchBoundary = input.value;
    }
  }

  private _selectCountiesChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchBoundary = input.value;
    }
  }

  private _selectDistrictsChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchBoundary = input.value;
    }
  }

  private _selectBoundaryChange(event?: MouseEvent) {
    // console.log("_selectBoundaryChange");
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchBoundarylayer = this.boundaryLayers[input.selectedIndex].id;
    }
    const serachParams = returnSearchParams(this.searchBoundarylayer);
    const prompt = document.getElementById("prompt") as HTMLElement;
    const mpoSelect = document.getElementById("selectMPO") as HTMLSelectElement;
    const urbanAreasSelect = document.getElementById("selectUrbanAreas") as HTMLSelectElement;
    const countiesSelect = document.getElementById("selectCounties") as HTMLSelectElement;
    const districtsSelect = document.getElementById("selectDistricts") as HTMLSelectElement;
    const townsSelect = document.getElementById("zoomSelectTowns") as HTMLInputElement;
    const townshipSelect = document.getElementById("zoomSelectTownship") as HTMLInputElement;
    const townsShow = document.getElementById("zoomShowTowns") as HTMLDivElement;
    const townshipShow = document.getElementById("zoomShowTownship") as HTMLDivElement;

    mpoSelect.style.display = "none";
    urbanAreasSelect.style.display = "none";
    countiesSelect.style.display = "none";
    districtsSelect.style.display = "none";
    townsShow.style.display = "none";
    townshipShow.style.display = "none";
    // townsSelect.style.display = "none";
    // townshipSelect.style.display = "none";
    if (this.inputText) {
      this.inputText.style.display = "none";
    }
    if (prompt) {
      prompt.innerText = serachParams.prompt;
    }
    if (this.searchBoundarylayer === layerSource.MPOAreasLayer.toString()) {
      this.searchBoundary = mpoSelect.value;
      mpoSelect.style.display = "block";
    } else if (this.searchBoundarylayer === layerSource.UrbanAreasLayer.toString()) {
      this.searchBoundary = urbanAreasSelect.value;
      urbanAreasSelect.style.display = "block";
    } else if (this.searchBoundarylayer === layerSource.IllinoisCountiesLayer.toString()) {
      this.searchBoundary = countiesSelect.value;
      countiesSelect.style.display = "block";
    } else if (this.searchBoundarylayer === layerSource.IDOTDistrictsLayer.toString()) {
      this.searchBoundary = districtsSelect.value;
      districtsSelect.style.display = "block";
    } else if (this.searchBoundarylayer === layerSource.IllinoisTownsLayer.toString()) {
      this.searchBoundary = townsSelect.value;
      townsShow.style.display = "block";
      // townsSelect.style.display = "block";
    } else if (this.searchBoundarylayer === layerSource.PoliticalTownshipsLayer.toString()) {
      this.searchBoundary = townshipSelect.value;
      townshipShow.style.display = "block";
      // townshipSelect.style.display = "block";
    } else {
      if (this.inputText) {
        this.inputText.style.display = "block";
        this.inputText.focus();
      }
    }
    this._showMessage("");
  }

  private _findBookmark(name: string): { name: string; extent: string } | null {
    let bookmark = null;
    this.bookmarksList.forEach((value, index) => {
      if (value.name.toLowerCase() === name.toLowerCase()) {
        bookmark = value;
      }
    });
    return bookmark;
  }

  private _selectBookmarksChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.selectBookmarks = input.value;

      const bookmark = this._findBookmark(input.value);
      if (bookmark && bookmark.name !== "" && bookmark.name !== "Select Bookmark") {
        //        console.log(" zoom to bookmark " + bookmark.name + " extent = " + bookmark.extent);
        if (bookmark.extent) {
          const extent = Extent.fromJSON(bookmark.extent);
          this.view.goTo(extent).then((value) => {
            // console.log("No error in goto");
          }).catch((error) => {
            // console.log("Error in Goto ", error)
          });
  
        }
      }
      if (this.inputText) {
        this.inputText.value = "";
      }
    }
    this._showMessage("");
  }

  private _selectMarkedRouteChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchMarkedRouteLayer = input.value;
      if (this.inputText) {
        this.inputText.focus();
      }
    }
  }

  private _clearResult() {
    clearGraphicType(this.view, "selected");
    this.view.popup.close();
    this._showMessage("");
  }

  private _showMessage(messageStr: string) {
    const message = document.getElementById("messageZoom");
    if (message) {
      message.innerText = messageStr;
    }
    document.body.style.cursor = "default";
  }

  private _highlightGeometry(geometry: Geometry) {
    try {
      if (geometry.extent) {
        this.selectedGraphic = new Graphic({
          geometry,
          attributes: { type: "selected" },
          symbol: new SimpleLineSymbol({
            color: highlightColor,
            width: 5 // points
          })
        });

        if (geometry instanceof Polygon) {
          this.view.popup.location = geometry.extent.center;
        } else {
          const nearest = geometryEngine.nearestVertex(this.selectedGraphic.geometry, geometry.extent.center);
          this.view.popup.location = nearest && nearest.coordinate ? nearest.coordinate : geometry.extent.center;
        }
        this.view.goTo(this.selectedGraphic.geometry.extent.expand(2)).then((value) => {
          // console.log("No error in goto");
          watchUtils.whenFalseOnce(this.view, "updating", () => {
            this.drawLayer.add(this.selectedGraphic);
          })
        }).catch((error) => {
          // console.log("Error in Goto ", error)
        });

      } else {
        this.selectedGraphic = new Graphic({
          geometry,
          attributes: { type: "selected" },
          symbol: new SimpleMarkerSymbol({
            style: "circle",
            color: "orange",
            size: "15px",
            outline: {
              color: [255, 255, 0],
              width: 3
            }
          })
        });
        this.view.goTo({
          target: this.selectedGraphic.geometry,
          zoom: 18
        }).then((value) => {
          watchUtils.whenFalseOnce(this.view, "updating", () => {
            this.drawLayer.add(this.selectedGraphic);
            this.view.popup.location = geometry as Point;
          });
        }).catch((error) => {
          // console.log("Error in Goto ", error)
        });
      }

    } catch (error) {
      console.error("Error: in _highlightGeometry " + error.message);
    }
  }

  private _popupFeatureChanged() {
    // console.log(" PopupFeature changed ", this.view.popup.selectedFeature);
    if (this.view.popup.selectedFeature) {
      clearGraphicType(this.view, "selected");

      if (this.view.popup.selectedFeature) {
        this._highlightGeometry(this.view.popup.selectedFeature.geometry);
      }
    }
  }

  private _showResult(graphics: Graphic[]) {
    // console.log("_showResults ", results, popup);
    try {
      if (graphics && graphics.length > 0) {
        // this._setSelectedGraphic(graphics[0]);

        this.view.popup.visible = false;
        this.view.popup.clear();

        let watchSelectedFeature:any;
        watchSelectedFeature = watchUtils.watch(this.view.popup, "selectedFeature", () =>
          this._popupFeatureChanged()
        );

        graphics.forEach(graphic => {
          if (graphic.hasOwnProperty('sourceLayer') && graphic['sourceLayer'] && graphic['sourceLayer'].popupTemplate) {
            graphic.popupTemplate = graphic['sourceLayer'].popupTemplate;
            graphic.popupTemplate.title = graphic['sourceLayer'].title;
          }
        });

        this.view.popup.set({
          title: "Zoom To Results",
          id: "ZoomTo",
          features: graphics, //  [graphics[0]], // featureSet.features,
          highlightEnabled: true,
        });

        this.view.popup.visibleElements.featureNavigation = true;

        this.view.popup.visible = true;
        this.zoomExpand.expanded = false;

        watchUtils.once(this.view.popup, "features", () => {
          // console.log("Undefine watchSelectedFeature?");
          if (watchSelectedFeature !== null) {
            watchSelectedFeature.remove();
          }
        });

        document.body.style.cursor = "default";
      } else {
        this._showMessage("Not Found !!");
      }
    } catch (error) {
      console.error("Error: in _showResult " + error.message);
      this._showMessage("Error in search !!");
    }
  }

  private _addRefGraphic(graphic: Graphic, station: number, isBegin: boolean) {
    try {
      const begSta = Number(graphic.attributes.BEG_STA);
      const endSta = Number(graphic.attributes.END_STA);

      const newPolygon = webMercatorUtils.webMercatorToGeographic(graphic.geometry) as Polyline;
      const line = webMercatorUtils.geographicToWebMercator(newPolygon) as Polyline;
      let stationPoint;

      if (Math.abs(endSta - station) < 0.0001) { // If specify end point, use end point
        stationPoint = new Point({
          x: line.paths[line.paths.length - 1][line.paths[0].length - 1][0],
          y: line.paths[line.paths.length - 1][line.paths[0].length - 1][1],
          spatialReference: line.spatialReference
        });
      }
      else {

        let dist = begSta;

        // console.log("\n\n");
        // console.log((isBegin ? "Add BegRef " : "Add EndRef ") + station + " Beg " + begSta + " End " + graphic.attributes.END_STA + " paths = " + line.paths.length);
        for (const path of line.paths) {
          // console.log(" Segemnts in path ", path.length);
          for (let i = 0; i < path.length - 1; i++) {
            const segLen = path[i+1][2] - dist;

            if (dist + segLen >= station || Math.abs(dist + segLen - station) < 0.0001) {
              const pctAlong = (station - dist) / segLen;
              // console.log(" dist " + dist + " segLen = " + segLen + " PctAlong = " + pctAlong + " pathIndex " + i);
              stationPoint = new Point({
                x: path[i][0] + (path[i+1][0] - path[i][0]) * pctAlong,
                y: path[i][1] + (path[i+1][1] - path[i][1]) * pctAlong,
                spatialReference: line.spatialReference
              });
              break;
            }
            dist += segLen;
          }
          if (stationPoint) {
            // console.log("break out of path loop if point found");
            break;
          }
        }
      }
      if (stationPoint) {
        const stationGraphic = new Graphic({
          symbol: new SimpleMarkerSymbol({
            style: "circle",
            color: isBegin ? "green" : "red",
            size: "18px"
          }),
          attributes: { type: "selected" },
          geometry: stationPoint
        });
        const stationTextGraphic = new Graphic({
          symbol: new TextSymbol({
            color: isBegin ? "green" : "red",
            text: station.toString(),
            xoffset: -17,
            yoffset: -17,
            font: {
              // autocast as new Font()
              size: 13,
              family: "sans-serif",
              weight: "bold"
            }
          }),
          attributes: { type: "selected" },
          geometry: stationPoint
        });

        this.drawLayer.add(stationTextGraphic);
        this.drawLayer.add(stationGraphic);
      }
    } catch (error) {
      console.error("Error: in _addRefGraphic " + error.message);
    }
  }

  private _addBegStaGraphic(graphic: Graphic) {
    try {
      const poly = graphic.geometry as Polyline;
      const firstPoint = new Point({
        x: poly.paths[0][0][0],
        y: poly.paths[0][0][1],
        spatialReference: poly.spatialReference
      });
      const lastPoint = new Point({
        x: poly.paths[poly.paths.length - 1][poly.paths[0].length - 1][0],
        y: poly.paths[poly.paths.length - 1][poly.paths[0].length - 1][1],
        spatialReference: poly.spatialReference
      });

      const ptGraphic1 = new Graphic({
        symbol: new SimpleMarkerSymbol({
          style: "circle",
          color: "blue",
          size: "4px"
        }),
        attributes: { type: "selected" },
        geometry: firstPoint
      });

      const textGraphic1 = new Graphic({
        symbol: new TextSymbol({
          color: "blue",
          text: graphic.attributes.BEG_STA.toFixed(2),
          xoffset: 13,
          yoffset: 13,
          verticalAlignment: "top",
          font: {
            // autocast as new Font()
            size: 10,
            family: "sans-serif"
          }
        }),
        attributes: { type: "selected" },
        geometry: firstPoint
      });

      const ptGraphic2 = new Graphic({
        symbol: new SimpleMarkerSymbol({
          style: "circle",
          color: "blue",
          size: "4px"
        }),
        attributes: { type: "selected" },
        geometry: lastPoint
      });

      const textGraphic2 = new Graphic({
        symbol: new TextSymbol({
          color: "blue",
          text: graphic.attributes.END_STA.toFixed(2),
          xoffset: 13,
          yoffset: 13,
          verticalAlignment: "top",
          font: {
            // autocast as new Font()
            size: 10,
            family: "sans-serif"
          }
        }),
        attributes: { type: "selected" },
        geometry: lastPoint
      });

      this.drawLayer.add(ptGraphic1);
      this.drawLayer.add(textGraphic1);
      this.drawLayer.add(ptGraphic2);
      this.drawLayer.add(textGraphic2);
    } catch (error) {
      console.error("Error: in _addBegStaGraphic " + error.message);
    }
  }

  private _showCombinedResult(graphics: Graphic[], showStations: boolean = true, begRef?: string, endRef?: string) {
    // console.log("_showCombinedResult ", graphics);
    try {
      if (graphics && graphics.length > 0) {
        // console.log("Combined Results total = ", graphics.length);

        this.view.popup.visible = false;
        this.view.popup.clear();
        this.zoomExpand.expanded = false;

        const allGeometry: Geometry[] = [graphics[0].geometry];
        for (let index = 1; index < graphics.length; index++) {
          allGeometry.push(graphics[index].geometry);
        }

        const combinedGeometry = geometryEngine.union(allGeometry);

        this._highlightGeometry(combinedGeometry);

        if (showStations) {
          // console.log("\n\nbegRef " + begRef + " endRef " + endRef);
          graphics.forEach(graphic => {
            const line = graphic.geometry as Polyline;
            graphic.attributes.BEG_STA = line.paths[0][0][2];
            graphic.attributes.END_STA = line.paths[line.paths.length-1][line.paths[line.paths.length-1].length-1][2];
            this._addBegStaGraphic(graphic);

            // Draw each vertex and label with M (MileStation)
            // line.paths.forEach(path => {
            //   path.forEach(point => {
            //     const firstPoint = new Point({
            //       x: point[0],
            //       y: point[1],
            //       spatialReference: line.spatialReference
            //     });
          
            //     const ptGraphic1 = new Graphic({
            //       symbol: new SimpleMarkerSymbol({
            //         style: "circle",
            //         color: "green",
            //         size: "2px"
            //       }),
            //       attributes: { type: "selected" },
            //       geometry: firstPoint
            //     });
          
            //     const textGraphic1 = new Graphic({
            //       symbol: new TextSymbol({
            //         color: "green",
            //         text: point[2].toFixed(3),
            //         xoffset: 13,
            //         yoffset: 13,
            //         verticalAlignment: "top",
            //         font: {
            //           // autocast as new Font()
            //           size: 10,
            //           family: "sans-serif"
            //         }
            //       }),
            //       attributes: { type: "selected" },
            //       geometry: firstPoint
            //     });
            //     this.drawLayer.add(ptGraphic1);
            //     this.drawLayer.add(textGraphic1);
            //   })
            // })
          });
          let begDone = false;
          let endDone = false;
          graphics.forEach(graphic => {
            if (begRef !== "" || endRef !== "") {
              const begRefNum = Number(begRef === "" ? -1 : begRef);
              const endRefNum = Number(endRef === "" ? -1 : endRef);
              const beg = graphic.attributes.BEG_STA;
              const end = graphic.attributes.END_STA;
              if (!begDone && (begRefNum >= beg || Math.abs(begRefNum - beg) < 0.0001) && begRefNum <= end) {
                begDone = true;
                this._addRefGraphic(graphic, begRefNum, true);
              }
              if (!endDone && endRefNum >= beg && (endRefNum <= end || Math.abs(endRefNum - end) < 0.0001)) {
                endDone = true;
                this._addRefGraphic(graphic, endRefNum, false);
              }
            }
          });
        }

        document.body.style.cursor = "default";
      } else {
        this._showMessage("Not Found !!");
      }
    } catch (error) {
      console.error("Error: in _showResult " + error.message);
      this._showMessage("Error in search !!");
    }
  }
}

export = ZoomTo;
